import * as React from "react";
import { Spinner } from "@fluentui/react/lib/Spinner";

import { TEXT } from "../../../../../shared/constants/texts";

type InstanceListingProps = {
  isLoading: any;
  loadingMsg: any;
  emptyMsg: any;
  instances: any;
  onInstanceClicked: any;
  selectedInstance: any;
  showMoreClicked: any;
};

const InstancesListing: React.FC<InstanceListingProps> = (props) => {
  const { isLoading, loadingMsg, emptyMsg, instances, onInstanceClicked, selectedInstance, showMoreClicked } = props;

  const onPressEnterInstance = (e, instance) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      onInstanceClicked(instance);
    }
  };

  const onPressEnterShowMore = (e) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      showMoreClicked();
    }
  };

  return (
    <div className="instances-listing-single-email-upload">
      {isLoading ? (
        <LoadingInstances msg={loadingMsg} />
      ) : instances && instances.length > 0 ? (
        <div>
          {instances.slice(0, 10).map((instance) => {
            const instanceName = instance.Name ? instance.Name : instance.ICMAgreementCode;
            let classNameForInstance = "single-instance-single-email-upload";
            if (selectedInstance && selectedInstance.EntityInstanceId === instance.EntityInstanceId) {
              classNameForInstance = "single-instance-selected-single-email-upload";
            }
            return (
              <div
                key={instance.EntityInstanceId}
                className={classNameForInstance}
                onClick={() => onInstanceClicked(instance)}
                tabIndex={1}
                onKeyDown={(e) => onPressEnterInstance(e, instance)}
              >
                <p>{instanceName}</p>
              </div>
            );
          })}
          {instances && instances.length > 10 ? (
            <div
              className="show-more-single-email-upload"
              onClick={showMoreClicked}
              tabIndex={1}
              onKeyDown={onPressEnterShowMore}
            >
              <span>{TEXT.SHOW_MORE}</span>
            </div>
          ) : null}
        </div>
      ) : (
        <EmptyInstances msg={emptyMsg} />
      )}
    </div>
  );
};

const LoadingInstances = (props) => {
  const { msg } = props;

  return (
    <div className="loading-instances-single-email-upload">
      <Spinner label={msg} labelPosition="right" />
    </div>
  );
};

const EmptyInstances = (props) => {
  const { msg } = props;

  return (
    <div className="empty-instances-single-email-upload">
      <p>{msg}</p>
    </div>
  );
};

export default InstancesListing;
